// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports
// JS Imports
import { formatFloatAsCurrencySymbol } from '../../../common/helpers.mjs'
// Asset Imports

export default function ResellerPrepayPriceRow() {
   const state = useQuoteContext()
   const { getString } = state

   if (state.resellerCustomerQuoteValues.prepayDiscountAmount > 0)
      return (
         <div className='row'>
            <div className='col-bhr1 col-bhr5'>
               {getString('product.ResellerPrepayPriceRow.Title')}
            </div>
            <div className='col'></div>
            <div className='col'></div>
            <div className='col col-bhr-red'>
               {formatFloatAsCurrencySymbol(
                  state.resellerCustomerQuoteValues.prepayDiscountAmount,
                  state.currencyObject,
               )}
            </div>
         </div>
      )
}
